import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { useOrganizationAlias } from "@domain/currentProfile/hooks";
import { ImageVersions } from "@domain/media/dtos";
import { Organization } from "@domain/organization/organization";
import { getBanner } from "@utils/banner";
import { BackgroundImage } from "@ui/components/backgroundImage";
import { Row, stack } from "@ui/components/layout";
import { OrganizationMenu } from "@ui/components/organization/organizationMenu";
import { FollowButton } from "@ui/components/profile/followButton";
import { ProfilePicture } from "@ui/components/profile/profilePicture";
import { OrganizationData } from "./organizationData";

interface MobileOrganizationHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
	organization: Organization;
}
export const MobileOrganizationHeader: React.FC<MobileOrganizationHeaderProps> = ({ organization, ...htmlProps }) => {
	const { id, banner, avatar, primaryName, description, type, subType } = organization;
	const alias = useOrganizationAlias();

	return (
		<div {...htmlProps}>
			<Container image={banner} defaultUrl={!banner ? getBanner(id) : undefined} size={ImageVersions.MEDIUM}>
				<PictureWrapper>
					<ProfilePicture shadowed picture={avatar} size="XL" fallbackType={type} />
				</PictureWrapper>
				{!alias && <AbsoluteFollowButton iconMode profile={organization} />}
				<Menu blur organization={organization} />
			</Container>
			<Infos>
				<Name>{primaryName}</Name>
				<OrganizationType>{I18n.t(`organization.type.${subType}`)}</OrganizationType>
				<div>{description}</div>
				<Row gap={14} align="center">
					<OrganizationData organization={organization} />
				</Row>
			</Infos>
		</div>
	);
};

const Container = styled(BackgroundImage)`
	height: 160px;
	margin-left: -15px;
	margin-right: -15px;
`;

const PictureWrapper = styled.div`
	position: absolute;
	left: 20px;
	bottom: 0;
	transform: translateY(50%);
`;

const Menu = styled(OrganizationMenu)`
	position: absolute;
	right: 10px;
	top: 10px;
`;

const Infos = styled.div`
	margin-top: 80px;
	${stack(16)};

	> button {
		margin-top: 20px;
	}
`;

const Name = styled.div`
	${({ theme }) => theme.textStyles.title};
`;

const AbsoluteFollowButton = styled(FollowButton)`
	position: absolute;
	right: 20px;
	bottom: 0;
	transform: translateY(50%);
`;

const OrganizationType = styled.div`
	${({ theme }) => theme.textStyles.label};
`;
